import React, { PureComponent, Fragment } from "react";
import { Button, withStyles, Box, IconButton } from "@material-ui/core";
import FormDialog from "../../../shared/components/FormDialog";
import ButtonCircularProgress from "../../../shared/components/ButtonCircularProgress";
import { TextField, makeValidate, makeRequired } from 'mui-rff';
import * as yup from 'yup';
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as AuthActions from "../../../redux/actions/auth";
import EmojiTextArea from "shared/components/EmojiTextArea";
import Dropzone from "shared/components/Dropzone";
import { /* Form, */ Field } from 'react-final-form'
import CloseIcon from "@material-ui/icons/Close";
import AddIcon from "@material-ui/icons/Add";
import DeleteIcon from "@material-ui/icons/Delete";
import { cdnURL } from './../../../shared/functions/api/'
import arrayMutators from 'final-form-arrays';
import { FieldArray } from 'react-final-form-arrays';
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import AccordionActions from '@material-ui/core/AccordionActions';
import Divider from '@material-ui/core/Divider';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

const schema = yup.object().shape({
  value: yup.string().required(),
});
const validate = makeValidate(schema);
const required = makeRequired(schema);

const styles = (theme) => ({
  floatButtonWrapper: {
    position: "absolute",
    top: 15,
    right: 15,
    zIndex: 1000,
    '& svg': {
      color: 'white',
      backgroundColor: '#0000003b',
      borderRadius: '50%',
      fontSize: 25,
    }
  },
  imgWrapper: { position: "relative", backgroundColor: '#AAA' },
  dropzone: {
    '& button': {
      padding: 0,
    }
  },
  img: {
    width: "100%",
    border: "1px solid rgba(0, 0, 0, 0.23)",
    borderRadius: theme.shape.borderRadius,
    borderTopLeftRadius: 0,
    borderBottomLeftRadius: 0
  },
  uploadText: {
    padding: 20,
    transition: theme.transitions.create(["color", "box-shadow", "border"], {
      duration: theme.transitions.duration.short,
      easing: theme.transitions.easing.easeInOut
    })
  },
  emojiTextArea: {
    borderTopRightRadius: 0,
    borderBottomRightRadius: 0,
    marginRight: -1
  },
});

class DynamicElementDialog extends PureComponent {

  state = {
    status: false
  };

  componentDidMount() {
    this.setState({ status: this.props.status })
  }

  componentDidUpdate(prevProps) {
    if (prevProps.status !== this.props.status) {
      this.setState({ status: this.props.status })
    }
  }

  setStatus(status) {
    this.setState({ status })
  }

  onDrop = (acceptedFiles, rejectedFiles) => {
    const { pushMessageToSnackbar } = this.props;
    if (acceptedFiles.length + rejectedFiles.length > 1) {
      pushMessageToSnackbar({
        isErrorMessage: true,
        text: "You cannot upload more than one file at once"
      });
    } else if (acceptedFiles.length === 0) {
      pushMessageToSnackbar({
        isErrorMessage: true,
        text: "The file you wanted to upload isn't an image"
      });
    } else if (acceptedFiles.length === 1) {
      const file = acceptedFiles[0];
      file.preview = URL.createObjectURL(file);
      file.key = new Date().getTime();
      this.setState({ files: [file] });
    }
  };

  printFile = (input) => {
    const { classes } = this.props;
    const { files } = this.state;

    const src = files && files[0] ? files[0].preview : input.value && cdnURL + input.value;

    return (
      <Dropzone
        accept="image/png, image/jpeg"
        onDrop={(accepted, rejected) => {
          this.onDrop(accepted, rejected);
          input.onChange(accepted[0]);
        }}
        fullHeight
        className={classes.dropzone}
      >
        {src &&
          <div className={classes.imgWrapper}>
            <img
              alt="uploaded item"
              src={src}
              className={classes.img}
            />
            <div className={classes.floatButtonWrapper}>
              <IconButton onClick={(e) => {
                this.setState({ files: [] });
                input.onChange('');
                e.stopPropagation();
              }}>
                <CloseIcon />
              </IconButton>
            </div>
          </div>
        }
        {!src &&
          <span className={classes.uploadText}>
            Click / Drop file <br /> here
        </span>
        }
      </Dropzone>
    );
  };

  render() {
    const { classes, onClose, initialValues, description, forceEnableSubmitButton, onBack, after } = this.props;
    const { status } = this.state;

    return (
      <Fragment>
        <FormDialog
          formStyle={{overflowY: 'auto'}}
          open
          status={status && status.general}
          onClose={onClose}
          validate={validate}
          initialValues={initialValues}
          onFormSubmit={(data) => this.props.onFormSubmit(data, { after })}
          headline="Edit Content"
          description={description || ""}
          maxWidth="md"
          mutators={{
            ...arrayMutators,
          }}
          content={({ submitting, values, form: { mutators: { push, pop } } }) =>
            <Fragment>

              {initialValues.type === 'text' &&
                <Field
                  name="value"
                  render={({ input, meta }) => (
                    <div>
                      <EmojiTextArea
                        inputClassName={classes.emojiTextArea}
                        input={input}
                        required={true}
                      />
                      {meta.error && meta.touched && <span>{meta.error}</span>}
                    </div>
                  )}
                />
              }


              {initialValues.type === 'image' && <React.Fragment>
                <Field
                  name="value"
                  render={({ input, meta }) => (
                    <React.Fragment>
                      {this.printFile(input)}
                      {meta.error && meta.touched && <span>{meta.error}</span>}
                    </React.Fragment>
                  )} />
                  <br/>
                  <br/>
                  <TextField margin="dense" label={`URL Link`} name={'url'} />
              </React.Fragment>}

              {initialValues.type === 'list' && <React.Fragment>
                <FieldArray name="value">
                  {({ fields }) => fields.map((name, index) => <React.Fragment>
                    <Accordion>
                      <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                      >
                        <Typography>{values.value[index].title}</Typography>
                      </AccordionSummary>
                      <AccordionDetails >
                        <div style={{width: '100%'}}>
                          <TextField margin="dense" label={`Title ${index + 1}`} name={name + '.title'} />
                          <br/>
                          <br/>
                          <Field
                            name={name + '.content'}
                            render={({ input, meta }) => (
                              <div>
                                <EmojiTextArea
                                  inputClassName={classes.emojiTextArea}
                                  input={input}
                                  required={true}
                                />
                                {meta.error && meta.touched && <span>{meta.error}</span>}
                              </div>
                            )}
                          />
                        </div>
                      </AccordionDetails>
                      <Divider />
                      <AccordionActions>
                        <Button
                          type="button"
                          color="default"
                          onClick={() => {
                            fields.remove(index)
                          }}
                          size="small"
                          variant="contained"
                          startIcon={<DeleteIcon />}
                        >
                          Remove
                        </Button>
                      </AccordionActions>


                    </Accordion>

                  </React.Fragment>)}
                </FieldArray>

                <br />
                <Button
                  variant="contained"
                  color="default"
                  size="medium"
                  startIcon={<AddIcon />}
                  onClick={() => push('value', { title: 'New Section', content: 'Content goes here...' })}
                >
                  Add Section
                </Button>
              </React.Fragment>
              }


            </Fragment>
          }
          actions={({ submitting, pristine }) =>
            <Fragment>
              <Button
                type="button"
                variant="contained"
                color="default"
                disabled={submitting}
                onClick={() => onBack ? onBack({ initialValues }) : onClose()}
              >
                Cancel
              </Button>

              <Button
                type="submit"
                variant="contained"
                color="secondary"
                disabled={(submitting || pristine) && !forceEnableSubmitButton}
              >
                Save
                {submitting && <ButtonCircularProgress />}
              </Button>

            </Fragment>
          }
        />
      </Fragment>
    );
  }
}

export default withStyles(styles, { withTheme: true })(connect(
  (state) => ({
    authUser: state.auth.user,
  }),
  (dispatch) => bindActionCreators({ ...AuthActions }, dispatch)
)(DynamicElementDialog));
